import { useFetchAuth } from './useFetchAuth'

const logout = () => {
  const { logout } = useFetchAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: logout,
    onMutate: () => {
      queryClient.cancelQueries()
    },
    onSettled: () => {
      queryClient.clear()
    },
  })
}

const requestMfaCode = () => {
  const { requestMfaCode } = useFetchAuth()
  return useMutation({ mutationFn: requestMfaCode })
}

const confirmMfa = () => {
  const { confirmMfa } = useFetchAuth()
  return useMutation({ mutationFn: confirmMfa })
}

export const useMutationAuth = ({
  logout,
  requestMfaCode,
  confirmMfa,
})
